/**
 * Checkt of een keyboard event de Enter toets is (inclusief NumpadEnter)
 */
export function isEnterKey(event: KeyboardEvent): boolean {
  return event.code === 'Enter' || event.code === 'NumpadEnter';
}
